function setClientEmailSettings({salutation, email, cc}) {
    document.getElementById('clientEmailSettings').innerHTML = `
        Klantinstellingen voor standaard werkbonmail:<br>
        Aanhef: ${escapeHtml(salutation) || '-'}<br>
        Email: ${escapeHtml(email) || '-'}<br>
        Cc: ${escapeHtml(cc) || '-'}
    `;
}

function getClientSettings(id, success) {
    $.ajax({
        type: 'GET',
        url: '/client/project-settings/' + id,
        success,
    });
}

$('#projectClientIdSelect').change(function() {
    let id = $(this).val();

    getClientSettings(id, function(data) {
        document.getElementById('projectBreakSelect').value = data.break;
        document.getElementById('project_nr_mcn').value = data.code;
        setClientEmailSettings(data);
    })
});

window.onload = function () {
    let id = $('#projectClientIdSelect').val();

    if (id) {
        getClientSettings(id, function (data) {
            setClientEmailSettings(data);
        })
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/project.js